<template>
    <div>
        <mml-base-header-sec></mml-base-header-sec>

        <div class="container-fluid base-container">
            <div class="base-box p-normal">
                <form class="w-100" v-on:keyup.enter="search">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Речи и изрази у називу</label>
                                <input type="text" v-model="title_query" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Речи и изрази у тексту</label>
                                <input type="text" v-model="text_query" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Област</label>
                                <select v-model="area" class="form-control full-width">
                                    <option v-for="item in filters.areas" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Доносилац / Аутор</label>
                                <select v-model="authority_type" class="form-control full-width">
                                    <option value="-1">Све групе доносилаца</option>
                                    <option v-for="item in filters.authority_types" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Назив доносиоца / Име аутора</label>
                                <select v-model="authority" class="form-control full-width">
                                    <option value="-1">Сви доносиоци</option>
                                    <option v-for="item in filters.authorities" v-bind:key="item.k" :label="item.l"
                                        :value="item.k">{{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group form-group-sm" v-if="filters.subjects.length > 0">
                                <label class="form-label">Материја</label>
                                <select v-model="subject" class="form-control full-width">
                                    <option v-for="item in filters.subjects" v-bind:key="item.k" :label="item.l"
                                        :value="item.k">{{ item.l }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Основни пропис</label>
                                <input type="text" v-model="primary_regulation" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Чланови</label>
                                <input type="text" v-model="members" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Други прописи</label>
                                <input type="text" v-model="secondary_regulation" class="form-control full-width">
                            </div>
                            <div class="form-group form-group-sm">
                                <label class="form-label">Извор</label>
                                <select v-model="source" class="form-control full-width">
                                    <option value="-1">Сви извори</option>
                                    <option v-for="item in filters.sources" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                            <div class="row" v-if="source == 1">
                                <div class="col-md-6">
                                    <div class="form-group form-group-sm">
                                        <label class="form-label">Година</label>
                                        <select v-model="year" class="form-control full-width">
                                            <option v-for="item in filters.years" v-bind:key="item" :value="item">
                                                {{ item }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group form-group-sm">
                                        <label class="form-label">Број</label>
                                        <select v-model="issue" class="form-control full-width">
                                            <option v-for="item in filters.issues" v-bind:key="item" :value="item">
                                                {{ item }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group form-group-sm" v-else-if="source > 1">
                                <label class="form-label">{{ subsource_label }}</label>
                                <select v-model="subsource" class="form-control full-width">
                                    <option v-for="item in filters.subsources" v-bind:key="item.k" :value="item.k">
                                        {{ item.l }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group form-group-sm">
                                <label class="form-label">Тип документа</label>
                                <select v-model="document_type" class="form-control full-width">
                                    <option value="0">Актуелни</option>
                                    <option value="1">Архивски</option>
                                </select>
                            </div>
                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум од</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateFrom"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesFrom"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->
                            <!--                            <b-form-group class="form-group-sm">-->
                            <!--                                <label class="form-label">Датум до</label>-->
                            <!--                                <datepicker-->
                            <!--                                        v-model="dateTo"-->
                            <!--                                        :full-month-name="true"-->
                            <!--                                        format="dd.MM.yyyy"-->
                            <!--                                        input-class="form-control full-width"-->
                            <!--                                        :calendar-button="true"-->
                            <!--                                        calendar-button-icon="icon-calendar1"-->
                            <!--                                        :clear-button="true"-->
                            <!--                                        :disabledDates="disabledDatesTo"-->
                            <!--                                        clear-button-icon="icon-x"-->
                            <!--                                        :bootstrap-styling="true" :language="srCYRL">-->
                            <!--                                </datepicker>-->
                            <!--                            </b-form-group>-->

                            <data-picker-mask-component ref="dataPickerMask" @datapiskerDateFromValue="emitedDateFrom"
                                @datapiskerDateToValue="emitedDateTo"></data-picker-mask-component>
                        </div>
                    </div>
                    <div class="spacer20"></div>
                    <div class="d-md-flex justify-content-between align-items-center">
                        <div class="form-group form-group-sm ">
                            <div class="form-inline ">
                                <label for="search_size" class="form-label mr-2">Величина резултата</label>
                                <select v-model="resultLimit" class="form-control">
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                    <option value="300">300</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group form-group-sm ">
                            <!--                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search">-->
                            <!--                                <span class="icon-search mr-2"></span>-->
                            <!--                                Претрага-->
                            <!--                            </button>-->

                            <button type="button" class="btn btn-base-submit text-uppercase mr-3" @click="search"
                                v-if="canOpen === 'can_open'">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#" @click.stop.prevent>
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>
                            <button type="button" class="btn btn-base-submit text-uppercase mr-3"
                                v-if="canOpen === 'role_not_allowed'" href="#" @click.stop.prevent="role_not_allowed()">
                                <span class="icon-search mr-2"></span>
                                Претрага
                            </button>

                            <button type="button" class="btn btn-base-reset text-uppercase" @click="reset">
                                <span class="icon-rotate-cw mr-2"></span>
                                Поништи све
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <result-counter :count="resultSize" :limit="resultLimit"></result-counter>

            <div class="base-box base-box__table-sec" v-if="result.length > 0">
                <!--                <sorted-table :values="result"-->
                <!--                              sort="type"-->
                <!--                              dir="asc"-->
                <!--                              class="table  table-striped table-sm table-slglrs"-->
                <!--                              ascIcon="<span> ▲</span>"-->
                <!--                              descIcon="<span> ▼</span>">-->
                <!--                    <thead>-->
                <!--                    <tr>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="type">Подврста</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="authority">Назив доносиоца / Име аутора</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="principalAct">Основни пропис</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="closerDesignation">Ближе одређење материје / назив</sort-link>-->
                <!--                        </th>-->
                <!--                        <th scope="col" style="text-align: center; width: 10rem;">-->
                <!--                            <sort-link name="sourceName">Начин објаве</sort-link>-->
                <!--                        </th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <template #body="sort">-->
                <!--                        <tbody>-->
                <!--                        <tr v-for="(item, index) in sort.values" v-bind:key="index">-->
                <!--                            <td>{{item.type}}</td>-->
                <!--                            <td>{{item.authority}}</td>-->
                <!--                            <td>{{item.principalAct}}</td>-->
                <!--                            <td><a :href="baseUrl +'mml/viewAct/naziv-akta/' + item.id" target="_blank">{{item.closerDesignation}}</a>-->
                <!--                            </td>-->
                <!--                            <td>{{item.sourceName}}</td>-->
                <!--                        </tr>-->
                <!--                        </tbody>-->
                <!--                    </template>-->
                <!--                </sorted-table>-->

                <b-table class="table-bootstrap-vue" striped bordered :items="result" :fields="fields" responsive="sm">
                    <template v-slot:cell(closerDesignation)="data">
                        <router-link target="_blank" :to="{ path: '/mml/viewAct/' + data.item.id }">{{
                            data.item.closerDesignation
                        }}</router-link>
                    </template>
                </b-table>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import MmlBaseHeaderSec from '@/base_pages/mml/MmlBaseHeaderSec.vue';
// import Datepicker from 'vuejs-datepicker';
import { srCYRL } from 'vuejs-datepicker/dist/locale'
// import {SortedTable, SortLink} from "vue-sorted-table";
import ResultCounter from '@/partials/ResultCounter.vue';
import { mapState } from 'vuex';


import DataPickerMaskComponent from '@/components/DataPickerMaskComponent.vue';
export default {
    name: "MmlQaSearchPage",
    data() {
        return {
            fields: [
                { label: 'Подврста', key: 'type', sortable: true },
                { label: 'Назив доносиоца / Име аутора', key: 'authority', sortable: true },
                { label: 'Основни пропис', key: 'principalAct', sortable: true },
                { label: 'Ближе одређење материје / назив', key: 'closerDesignation', sortable: true },
                { label: 'Начин објаве', key: 'sourceName', sortable: true },
            ],

            emitedDateFromVal: null,
            emitedDateToVal: null,

            srCYRL: srCYRL,
            isActOpen: false,
            actHTML: '',
            result: [],
            resultSize: null,
            resultLimit: 50,
            baseMMLApiUrl: window.env.VUE_APP_API_MML_DEV,
            baseDIApiUrl: window.env.VUE_APP_API_DI_DEV,


            members: '',
            primary_regulation: '',
            secondary_regulation: '',
            title_query: '',
            text_query: '',

            authority: -1,
            authority_type: -1,
            source: -1,
            subsource: -1,
            area: -1,

            document_type: 0,
            dateFrom: null,
            dateTo: null,

            filters: {
                authorities: [],
                authority_types: [],
                areas: [],
                sources: [],
                subsources: [],
                subjects: [],
            },
            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    components: {
        MmlBaseHeaderSec,
        // Datepicker,
        // SortedTable,
        // SortLink,
        ResultCounter,
        DataPickerMaskComponent,
    },
    computed: {
        subsource_param: function () {
            if (this.source == 1) {
                return this.issue + '/' + this.year;
            }
            return null;
        },
        subsource_label: function () {
            for (var i = 0; i < this.filters.sources.length; i++) {
                if (this.filters.sources[i].k == this.source) {
                    console.log(this.filters.sources[i].l);
                    return this.filters.sources[i].l;
                }
            }
            return null;
        },
        disabledDatesFrom: function () {
            if (this.dateTo === null) {
                return { from: new Date }
            } else return { from: this.dateTo }
        },
        disabledDatesTo: function () {
            if (this.dateFrom === null) {
                return { from: new Date }
            } else return { to: this.dateFrom, from: new Date }
        },


        ...mapState(['userInfoState']),
        canOpen() {
            if (this.userInfoState) {
                if (this.userInfoState.roles.includes('LSD')) {
                    return 'can_open';
                } else {
                    return 'role_not_allowed';
                }
            } else {
                return 'not_logged_in';
            }
        },
    },
    methods: {
        emitedDateFrom(e) {
            this.emitedDateFromVal = e;
        },
        emitedDateTo(e) {
            this.emitedDateToVal = e;
        },
        role_not_allowed() {
            alert('Немате приступ овој бази');
        },
        fetchData() {
            axios.get(this.baseMMLApiUrl + 'prins/qaSearch/filter?archived=' + (this.document_type == 0 ? 'false' : 'true'))
                .then(response => {
                    this.filters.authority_types = response.data.authorityGroups;
                    this.filters.authorities = response.data.authorityKinds;
                    this.filters.sources = response.data.sourceKinds;
                    this.filters.areas = response.data.subtypes;

                    this.filters.opinion_types = response.data.opinionTypes;

                    this.filters.sources = response.data.sourceKinds;

                    this.reset();

                    if (this.$route.query.q !== undefined) {
                        this.primary_regulation = this.$route.query.q;
                    }
                    if (this.$route.query.article !== undefined) {
                        this.members = this.$route.query.article;
                    }
                });
        },
        search() {

            // // Local DATA
            // let responseLocal = {"limit":50,"resultSize":1232,"result":[{"id":"11190","type":"Заштита људских права/Забрана дискриминације","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":"Закон о заштити података о личности","closerDesignation":"Лице за заштиту података о личности","sourceName":"Вебсајт Повереника","date":"26.12.2019","year":2019},{"id":"11191","type":"Заштита људских права/Забрана дискриминације","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":"Закон о заштити података о личности","closerDesignation":"Упутство за попуњавање и обрасци контролних листа","sourceName":"Вебсајт Повереника","date":"26.12.2019","year":2019},{"id":"11201","type":"Заштита људских права/Забрана дискриминације","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":"Закон о заштити података о личности","closerDesignation":"Ситуације у којима је дозвољена обрада података без пристанка лица на које се подаци односе","sourceName":"Вебсајт Повереника","date":"05.11.2019","year":2019},{"id":"10968","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пензијском и инвалидском осигурању","closerDesignation":"Обавеза плаћања доприноса за социјално осигурање за оснивача нерезидентно физичко лице, који је осигуран у матичној земљи са којом Република Србија има закључен Споразум о социјалном осугурању","sourceName":"Вебсајт Управе","date":"22.10.2019","year":2019},{"id":"10960","type":"Борба против корупције/Спречавање прања новца/Заштита узбуњивача","authority":"Управа за спречавање прања новца","principalAct":"Закон о спречавању прања новца и финансирања тероризма","closerDesignation":"Утврђивање идентитета странке без физичког присуства приликом закључивања Уговора о посредовању у промету непокретности","sourceName":"Вебсајт Управе","date":"21.10.2019","year":2019},{"id":"10962","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезу на добит правних лица","closerDesignation":"Пореска пријава нерезидентног правног лице које плаћа порез по одбитку у држави чији је резидент","sourceName":"Вебсајт Управе","date":"21.10.2019","year":2019},{"id":"10963","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезу на додату вредност","closerDesignation":"Право на рефундацију ПДВ за чланове породице купца првог стана ако на дан овере уговора о купопродаји стана нису имали исто пребивалиште","sourceName":"Вебсајт Управе","date":"21.10.2019","year":2019},{"id":"10961","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Подношење Изјаве о неактивности од стране правног лица приликом пријаве пореза на добит","sourceName":"Вебсајт Управе","date":"21.10.2019","year":2019},{"id":"10966","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пензијском и инвалидском осигурању","closerDesignation":"Обавезу плаћања доприноса за социјално осигурање по основу самосталне делатности власника предузетничке радње-нерезидента који је осигуран у матичној земљи","sourceName":"Вебсајт Управе","date":"21.10.2019","year":2019},{"id":"10965","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезу на додату вредност","closerDesignation":"Обрачунавање и плаћање ПДВ приликом продаје половног моторног возила за који је при набавци плаћен порез на пренос апсолутних права","sourceName":"Вебсајт Управе","date":"21.10.2019","year":2019},{"id":"10974","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о поступку уписа у катастар непокретности и водова","closerDesignation":"Упис заједничке својине по основу стицања у току трајања заједнице живота у браку у катастар непокретности код уговора о деоби и уговора о размени– Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10975","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о поступку уписа у катастар непокретности и водова","closerDesignation":"Обавеза јавног бележника да утврђује да ли је предмет уговора у режиму заједничке или посебне имовине – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10978","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о експропријацији","closerDesignation":"Обавеза јавног бележника да обавести учеснике у правном послу да је експропријација забележена и да нема дејства према кориснику експропријације – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10973","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о јавном бележништву","closerDesignation":"Oвера потврдe о животу од стране јавног бележника – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Народне скупштине","date":"21.10.2019","year":2019},{"id":"10976","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о поступку уписа у катастар непокретности и водова","closerDesignation":"Упис у катастар непокретности заједничке својине супружника када предузетник купује непокретност – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10977","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о експропријацији","closerDesignation":"Непостојање обавезе јавног бележника да приликом солемнизације правног посла којим се стиче или мења стварно право на непокретности обавести корисника експропријације – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10995","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о озакоњењу објеката","closerDesignation":"Oверa уговорa о промету непокретности када на парцели која је предмет уговора неки помоћни објекти нису легални, већ се налазе у поступку озакоњења, уз поуку о озакоњењу – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"11000","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о планирању и изградњи","closerDesignation":"Овера уговора о преносу трајног коришћења паркинг места од стране јавног бележника – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"11001","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о озакоњењу објеката","closerDesignation":"Солемнизација уговора о промету непокретности којем је предмет објекат изграђен без одобрења за градњу, а за који у катастру непокретности није уписана забележба забране отуђења - Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10998","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о наслеђивању","closerDesignation":"Уговор о уступању и расподели имовине за живота – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10997","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о озакоњењу објеката","closerDesignation":"Овера уговора у случају када је на земљишту и на објекту као облик својине уписана приватна својина, али је објекат изграђен без одобрења за градњу, а налази се у поступку озакоњења – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10999","type":"Правда","authority":"Јавнобележничка комора","principalAct":"Закон о хипотеци","closerDesignation":"Накнадни уговор – Питања и одговори Стручног савета Јавнобележничке коморе Србије","sourceName":"Вебсајт Коморе","date":"21.10.2019","year":2019},{"id":"10861","type":"Борба против корупције/Спречавање прања новца/Заштита узбуњивача","authority":"Управа за спречавање прања новца","principalAct":"Закон о спречавању прања новца и финансирања тероризма","closerDesignation":"Поверавање вршења појединих радњи и мера познавања и праћења странке трећем лицу, које није из круга трећих лица из члана 30. став 2. тачка 1. Закона о спречавању прања новца и финансирања тероризма","sourceName":"Вебсајт Управе","date":"01.10.2019","year":2019},{"id":"10860","type":"Привреда","authority":"Агенција за привредне регистре","principalAct":"Закон о поступку регистрације у Агенцији за привредне регистре","closerDesignation":"Обавеза регистрације адресе за пријем електронске поште","sourceName":"Вебсајт Агенције","date":"01.10.2019","year":2019},{"id":"11194","type":"Заштита људских права/Забрана дискриминације","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":"Закон о заштити података о личности","closerDesignation":"Обавеза именoвања лица за заштиту података у приватним апотекама","sourceName":"Вебсајт Повереника","date":"24.09.2019","year":2019},{"id":"11193","type":"Заштита људских права/Забрана дискриминације","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":"Закон о заштити података о личности","closerDesignation":"Прибављање пристанка за обраду података о личности","sourceName":"Вебсајт Повереника","date":"09.09.2019","year":2019},{"id":"10710","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Поступак подношења пореске пријаве ППДГ-1С","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10711","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Подношење измењене пореске пријаве","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10713","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Oстваривање права на повраћај више или погрешно плаћеног пореза","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10712","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Захтев за исправку грешке","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10716","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезу на добит правних лица","closerDesignation":"Подношење пореске пријаве од стране резидентног правног лица које није имало потврду о резидентности","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10714","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Рок за подношење захтева за повраћај више или погрешно плаћеног пореза","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10715","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Могућност плаћања пореског дуга на рате и отписа камате","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10722","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Износ пореза за предузетнике - паушалце","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10724","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезу на доходак грађана","closerDesignation":"Подношење ППДГ-1Р","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10723","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Подношење захтева за паушално опорезивање Пореској управи","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10718","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезима на имовину","closerDesignation":"Пореске картице рачуна јавних прихода Пореске управе","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10720","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезима на имовину","closerDesignation":"Пријава против лица које не издаје фискалне рачуне и не плаћа порезе","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10721","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезима на имовину","closerDesignation":"Плаћање пореза на паушално утврђени приход","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10719","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезима на имовину","closerDesignation":"Повлачење добијеног овлашћења за подношење пореске пријаве електронским путем","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10717","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о порезима на имовину","closerDesignation":"Информације у вези са порезом на имовину","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10726","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Попуњавање пореске пријаве ПП ОПО у случају издавања у закуп непокретности физичком лицу","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10725","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Подношење пореске пријаве на обрасцу ПП ОПО","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10727","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Подносилац пореске пријаве у случају када физичко лице издаје непокретност правном лицу","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10728","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Обавеза подношења пореске пријаве пореза на добит правних лица од стране недобитне организације","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"10709","type":"Финансије","authority":"Пореска управа","principalAct":"Закон о пореском поступку и пореској администрацији","closerDesignation":"Питања и одговори у вези члана 25. став 1. Закона о пореском посупку и пореској администрацији","sourceName":"Вебсајт Управе","date":"02.09.2019","year":2019},{"id":"11192","type":"Заштита људских права/Забрана дискриминације","authority":"Повереник за информације од јавног значаја и заштиту података о личности","principalAct":"Закон о заштити података о личности","closerDesignation":"Објављивање података о лицу за заштиту података","sourceName":"Вебсајт Повереника","date":"02.09.2019","year":2019},{"id":"10695","type":"Радни односи","authority":"Републичка агенција за мирно решавање радних спорова","principalAct":"Закон о мирном решавању радних спорова","closerDesignation":"Најчешће постављана питања у вези са применом Закона о мирном решавању радних спорова","sourceName":"Вебсајт Агенције","date":"26.08.2019","year":2019},{"id":"10677","type":"Финансије","authority":"Народна банка","principalAct":"Одлука о управљању ризиком концентрације по основу изложености банке одређеним врстама производа","closerDesignation":"Одговори на најчешће постављана питања у вези са Одлуком о управљању ризиком концентрације по основу изложености банке одређеним врстама производа (1–12)","sourceName":"Вебсајт Народне банке","date":"16.08.2019","year":2019},{"id":"10678","type":"Финансије","authority":"Народна банка","principalAct":"Одлука о адекватности капитала банке","closerDesignation":"Одговори на најчешће постављана питања у вези са Одлуком о измени одлуке о изменама и допуни одлуке о адекватности капитала банке (1–16)","sourceName":"Вебсајт Народне банке","date":"16.08.2019","year":2019}]};
            // this.result = responseLocal.result;
            // this.resultSize = responseLocal.resultSize;



            const vm = this;
            var url = this.baseDIApiUrl + 'mml/qaSearch';
            var data = {
                aai: this.subject,
                agi: this.authority_type,
                aki: this.authority,
                qati: this.area,
                ar: this.document_type,
                // df: this.dateFrom,
                // dt: this.dateTo,
                df: this.emitedDateFromVal,
                dt: this.emitedDateToVal,
                limit: this.resultLimit,
                oa: (this.secondary_regulation == '') ? null : this.secondary_regulation,
                pa: (this.primary_regulation == '') ? null : this.primary_regulation,
                paa: (this.members == '') ? null : this.members,
                sid: this.subsource,
                ski: this.source,
                src: null,
                bk: (this.text_query == '') ? null : this.text_query,
                tk: (this.title_query == '') ? null : this.title_query,
            };
            axios.post(url, data)
                .then(response => {
                    this.result = response.data.result;
                    this.resultSize = response.data.resultSize;
                }).catch(error => {
                    if (error.response.status === 401) {
                        // nije ulogovan
                        // otvori modal za logovanje
                        vm.$root.$emit('bv::show::modal', 'login-modal', '#btnShow')
                    }
                });

        },
        reset() {
            this.authority_type = -1;
            this.authority = -1;
            this.source = -1;
            this.subsource = -1;
            this.area = -1;

            this.members = '';
            this.primary_regulation = '';
            this.secondary_regulation = '';
            this.title_query = '';
            this.text_query = '';

            this.dateFrom = null;
            this.dateTo = null;

            this.resultLimit = 50;

            this.result = [];
            this.resultSize = null;
            this.$refs.dataPickerMask.resetDate();
        },
        fetchSubsources(url) {
            axios.get(this.baseMMLApiUrl + url)
                .then(response => {
                    this.filters.subsources = response.data;
                });
        }
    },
    watch: {
        document_type: function () {
            this.fetchData();
        },
        authority_type: function () {
            this.authority = -1;
            axios.get(this.baseMMLApiUrl + 'prins/qaSearch/filter?archived=' + (this.document_type == 0 ? 'false' : 'true')
                + '&authorityGroupId=' + this.authority_type)
                .then(response => {
                    this.filters.authorities = response.data.authorityKinds;
                })
        },
        authority: function () {
            this.subject = -1;
            if (this.authority > 0) {
                axios.get(this.baseMMLApiUrl + 'prins/authorityArea/3/' + this.authority + '?archived=' + (this.document_type == 0 ? 'false' : 'true'))
                    .then(response => {
                        this.filters.subjects = response.data;
                    })
            } else {
                this.filters.subjects = [];
            }
        },
        year: function () {
            this.fetchIssues(this.year);
        },
        source: function () {
            switch (this.source) {
                case 5:
                    this.fetchSubsources('prins/websites/3');
                    break;
                case 6:
                    this.fetchSubsources('prins/glasnikIssues/3');
                    break;
                case 24:
                    this.fetchSubsources('prins/otherIssues/3');
                    break;
                default:
                    break;
            }

            if (this.filters.subsources.length > 0) {
                this.subsource = this.filters.subsources[0].k;
            }

            if (this.filters.years.length > 0) {
                this.year = this.filters.years[0];
            }

            if (this.filters.issues.length > 0) {
                this.issue = this.filters.issues[0];
            }
        },
        resultLimit: function () {
            this.resultSize = null;
        }
    },
    created() {
        this.fetchData();
    },
    beforeCreate: function () {
        document.body.className = 'color_mml';
    }
}
</script>

<style >
.table-bootstrap-vue thead tr th:nth-child(1) {
    width: 10%;
}

.table-bootstrap-vue thead tr th:nth-child(2) {
    width: 20%;
}

.table-bootstrap-vue thead tr th:nth-child(3) {
    width: 30%;
}

.table-bootstrap-vue thead tr th:nth-child(4) {
    width: 30%;
}

.table-bootstrap-vue thead tr th:nth-child(5) {
    width: 10%;
}
</style>
